import { useEffect, useState } from 'react'

import { isArray } from 'lodash'
import { useSelector } from 'react-redux'

import { getIdOrNull, isOptimistic } from '../..'
import { getInstitutionSectors } from '../institution'
import { selectUser } from '../../../reducers/UserReducer'

const PARAMETERS = { archived: false, strictMode: false, orderBy: 'name' }

/**
 * Returns the selectable sectors of an institution, ordered by name, along with the
 * setter, so a caller creating a sector of its own can seat it in the list at once.
 *
 * The list is emptied as soon as the institution changes, so the sectors of the
 * previous one are never offered, and a response landing out of order is dropped.
 *
 * The institution is compared by identity, so pass a stable entity rather than
 * an object built inline, which would refetch on every render.
 */
const useInstitutionSectors = institution => {
  const user = useSelector(selectUser)

  const [sectors, setSectors] = useState([])

  useEffect(() => {
    let active = true

    setSectors(prev => (prev.length === 0 ? prev : []))

    if (getIdOrNull(institution) !== null && !isOptimistic(institution)) {
      getInstitutionSectors(user, institution, PARAMETERS)
        .then(({ data }) => {
          if (active) {
            setSectors(isArray(data) ? data : [])
          }
        })
        .catch(error => {
          console.error(error)

          if (active) {
            setSectors(prev => (prev.length === 0 ? prev : []))
          }
        })
    }

    return () => {
      active = false
    }
  }, [user, institution])

  return [sectors, setSectors]
}

export default useInstitutionSectors
